module.exports = __webpack_public_path__ + "img/search.7cbbb8e7.svg";